import {Observable} from "rxjs";
import {Product} from "../../../product/domain/dtos/product";

export abstract class CheckStockRemote {
    /**
     *  Checks the stock availability of a product.
     *  @param product - The product whose stock is being checked.
     *  @returns An observable emitting the available quantity of the product.
     */
    public abstract checkStock(product: Product): Observable<number>;
}
